import React from 'react'
import { withRouter } from 'react-router-dom'
import filter from 'lodash/filter'
import { searchDiscoverRepos } from '../../services/search/discoverSearchService'
import subjects from '../../staticData/subjects'
import DiscoverELAKeyTextsPage from './DiscoverELAKeyTextsPage'
import DiscoverBiologyPage from './DiscoverBiologyPage'
import DiscoverEarlyMathPage from './DiscoverEarlyMathPage'
import analytics from '../../utils/cdpAnalytics'

const REPOS_PER_SECTION = 12

class DiscoverPage extends React.Component {
  constructor(props) {
    super(props)
    this.filterRepos = this.filterRepos.bind(this)
    this.fetchRepos = this.fetchRepos.bind(this)
    let latestRepos = []
    if (props.discoverLatestRepos && props.discoverLatestRepos[props.subject]) {
      latestRepos = props.discoverLatestRepos[props.subject]
    }
    this.state = {
      latestRepos,
      popularRepos: [],
      highlyRatedRepos: [],
    }
  }

  componentDidMount() {
    analytics.page('Discover Subject Page', {
      type: this.props.subject,
    })
    this.fetchRepos()
  }

  fetchRepos() {
    const { subject } = this.props
    const { latestRepos } = this.state

    // Latest repos are cached in Redux, so only fetch them when the cache is cold.
    if (!latestRepos || latestRepos.length === 0) {
      searchDiscoverRepos({ subject, sort: 'latest', limit: REPOS_PER_SECTION })
        .then((hits) => {
          this.setState({ latestRepos: hits })
          this.props.onFetchLatestRepos(subject, hits)
          hits.forEach((repo) => {
            this.props.loadRepoContent(repo.id)
          })
        })
        // leave whatever is on screen rather than flashing to empty
        .catch(() => {})
    }

    searchDiscoverRepos({ subject, sort: 'popular', limit: REPOS_PER_SECTION })
      .then((hits) => {
        this.setState({ popularRepos: hits })
      })
      .catch(() => {})

    searchDiscoverRepos({ subject, sort: 'rated', limit: REPOS_PER_SECTION })
      .then((hits) => {
        this.setState({ highlyRatedRepos: hits })
      })
      .catch(() => {})
  }

  filterRepos(repos) {
    const unfilteredRepos = repos
    let filteredRepos = unfilteredRepos
    const selectedSubject = this.props.selectedSubSubject
    if (repos && selectedSubject) {
      const { subjectId } = subjects[selectedSubject]
      filteredRepos = filter(filteredRepos, (repo) => {
        if (repo.subject.id === subjectId) {
          return repo
        }
      })
    }
    return filteredRepos
  }

  render() {
    const { repos, subject } = this.props
    const filteredRepos = this.filterRepos(repos)
    if (subject === 'biology') {
      return (
        <DiscoverBiologyPage
          fetchAPublishedRepoByShortId={this.props.fetchAPublishedRepoByShortId}
          showNotification={this.props.showNotification}
          repos={filteredRepos}
          history={this.props.history}
          latestRepos={this.state.latestRepos}
          popularRepos={this.state.popularRepos}
          highlyRatedRepos={this.state.highlyRatedRepos}
          loadRepoContent={this.props.loadRepoContent}
        />
      )
    } if (subject === 'keyTexts') {
      return (
        <DiscoverELAKeyTextsPage
          fetchAPublishedRepoByShortId={this.props.fetchAPublishedRepoByShortId}
          showNotification={this.props.showNotification}
          repos={filteredRepos}
          history={this.props.history}
        />
      )
    } if (subject === 'earlyMath') {
      return (
        <DiscoverEarlyMathPage
          fetchAPublishedRepoByShortId={this.props.fetchAPublishedRepoByShortId}
          showNotification={this.props.showNotification}
          repos={filteredRepos}
          history={this.props.history}
          latestRepos={this.state.latestRepos}
          popularRepos={this.state.popularRepos}
          highlyRatedRepos={this.state.highlyRatedRepos}
          loadRepoContent={this.props.loadRepoContent}
        />
      )
    } return (
      <div className='page page--wideLayout discover'>
        <div className='page-leftPanel' />
        <div className='page-centerPanel'>
          <div className='discover-repoListContainer'>
            <div className='discover-repoList-header' />
            <div className='discover-repoList-list' />
          </div>
        </div>
        <div className='page-rightPanel' />
      </div>
    )
  }
}

export default withRouter(DiscoverPage)
